<template>
  <div class="" style="display: flex; align-items: center; justify-content: center;flex-direction: column;;height: 100vh;">
    <div
      class=""
      style="
        width: 88px;
        height: 88px;
        background-color: rgb(231, 238, 255);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <img
        style="width: 32px; "
        src="https://img.zhanshangxiu.com/showonline/file/202509/20250904/e6fd6219142246c58fa90e3f92a36c7b.png"
        alt=""
      />
    </div>
    <div style="color: #000000;font-size: 20px;margin-top: 25px;">该展会已被限制访问</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
